// import * as Routes from '../constants/routes';
// import { trackingEvent } from '../helpers/tracking';

// import Intro from '../calculators/pay-yourself-first/containers/intro';
import StartEducationPlanning from '../calculators/education-planning/containers/start-education-planning';
import RESPTaxBenefits from '../calculators/education-planning/containers/resp-tax-benefits';

export const name = 'Education Planning';

export const inSecondaryMenu = true;

export const routes = [
    // {
    //     path: Routes.HOME,
    //     component: Intro,
    //     pagination: false,
    //     progressBar: false
    // },
    {
        path: '/start-education-planning',
        name: 'Start Education Planning Now',
        component: StartEducationPlanning,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    },
    {
        path: '/resp-tax-benefits',
        name: 'Tax Benefits of an RESP',
        component: RESPTaxBenefits,
        progressBar: false,
        pagination: {
            next: false,
            previous: false
        }
    }
];
